export function parseBoolean(value) {
  return value === true || value === 1 || value === "1" || value === "true";
}
